<template>
    <div class="page-container">
        <div class="container-filter">
            <el-form ref="filterRef" :model="params" inline>
                <div>
					<el-form-item prop="range" label="发货日期：">
                        <el-date-picker v-model="params.range" type="daterange" :clearable="false" placeholder="选择日期" />
                    </el-form-item>
                    <el-form-item prop="order" label="订单型号：">
                        <el-input v-model="params.order" placeholder="请输入订单型号" clearable />
                    </el-form-item>
                </div>
                <div>
                    <el-button @click="resetFilter">重置</el-button>
                    <el-button type="primary" @click="getTableData()" :loading="loading">查询</el-button>
                </div>
            </el-form>
        </div>
        <div class="container-table">
            <div class="table-header">
                <div>数据列表</div>
                <div>
                    <el-button type="primary" @click="exportRecord">导出</el-button>
                </div>
            </div>
            <el-table :border="true" :data="table.data" v-loading="loading" >
                <el-table-column prop="" label="序号" fixed="left">
                    <template #default="{ $index }">
                        <span>{{ $index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="send_timeStr" label="发货日期" />
                <el-table-column prop="order" label="订单型号" />
                <el-table-column prop="custom" label="收货人（客户）" />
                <el-table-column prop="phone" label="联系电话"/>
                <el-table-column prop="order_num" label="订单数量"/>
                <el-table-column prop="address" label="发货地址"/>
                <el-table-column prop="ems" label="物流"/>
                <el-table-column prop="ems_num" label="物流号"/>
                <el-table-column label="操作" width="100" fixed="right">
                    <template #default="{ row }">
                        <el-button type="primary" size="small" @click="handleInfo(row)" v-if="mypowerlimits.ckqd_xq">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="tabler-pagination">
                <el-pagination
                    @size-change="getTableData()"
                    @current-change="getTableData"
                    :current-page="params.page"
                    :page-sizes="[20, 50, 100, 1000]"
                    v-model:page-size="params.page_size"
                    :total="table.total"
                    layout="total, sizes, prev, pager, next, jumper"
                />
            </div>
        </div>
        <Info :data="detail" @cancel="cancel" />
    </div>
</template>

<script setup>

import { ref, reactive } from 'vue'
import { View, Close } from '@element-plus/icons'
import http from '@/assets/js/http'
import Info from './Info.vue'

// 获取权限
const mypowerlimits = reactive(JSON.parse(localStorage.getItem('powerlimits')))

// 过滤
const filterRef = ref()
const params = reactive({
    range: [],
	order: '',
    page: 1,
    page_size: 20
})

// 表格
const loading = ref(false)
const table = reactive({
    data: [],
    columns: [],
    total: 0
})

const getTableData = async (page = 1) => {
	params.page = page
    loading.value = true
    try {
        const res = await http.get('WarehouseConfig/outList', { params: getParams() })
		Object.assign(table, res)
    } catch (e) {
        console.log(e)
    }
    loading.value = false
}

// 操作
// 重置查询条件
const resetFilter = () => {
    filterRef.value?.resetFields()
    getTableData()
}

// 导出
const exportRecord = async () => {
    await http.get('WarehouseConfig/outList', { params: getParams(true), sMsg: true })
}

const getParams = (exp = false)=> {
    const { range, order, page, page_size } = params
	const [start, end] = range
    const send_time = (start && end) ? `${start.valueOf() / 1000} ~ ${end.valueOf() / 1000}` : ''
	const _params = { send_time, order, page, page_size }
	if(exp) _params.export = 1
	return _params
}


const detail = ref({})
const handleInfo = (row)=> {
    detail.value = row.display
}

const cancel = ()=> {
    detail.value = {}
}

getTableData()
</script>

<style lang="scss" scoped>
.page-container {
    background-color: #e9eef3;
    .container-filter {
        padding: 12px 24px;
        background-color: #fff;
        .el-form {
            display: flex;
            justify-content: space-between;
        }
        .el-form-item {
            margin-right: 20px;
            margin-bottom: 0px;
        }
    }

    .container-table {
        margin-top: 4px;
        padding: 24px;
        background-color: #fff;
        .table-header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
        }

        .skip {
            cursor: pointer;
            color: var(--el-color-primary);
        }
        .tabler-pagination {
            display: flex;
            justify-content: space-between;
            margin-top: 12px;
        }
    }
}

.container-drawer {
    .filter-tree {
        margin-top: 24px;
    }
    .drawer-footer {
        margin-top: 24px;
        display: flex;
        justify-content: flex-end;
    }
}
</style>
